export const rentalBillingKeys = {
    all: ['rental-billing'] as const,
    preview: (jobId: string, billThrough: string) =>
        [...rentalBillingKeys.all, 'preview', jobId, billThrough] as const,
    projectPreview: (projectId: string, billThrough: string, stintIds: string[] = []) =>
        [...rentalBillingKeys.all, 'project-preview', projectId, billThrough, ...stintIds] as const,
}
